import type { Participant } from "@/api/api.types";
import type { Pagination } from "@/ui/common/TableComponent";
import TableComponent from "@/ui/common/TableComponent/TableComponent";
import { columns } from "./PendingAcceptanceColumns";

interface PendingAcceptanceTableProps {
  isLoading: boolean;
  isSearching: boolean;
  participants: Participant[];
  pagination: Pagination;
}

export const PendingAcceptanceTable = ({
  isLoading,
  isSearching,
  participants: participants,
  pagination,
}: PendingAcceptanceTableProps) => {
  return (
    <TableComponent
      isLoading={isLoading}
      data={participants}
      noDataMessage={
        isSearching
          ? "No participants match your search."
          : "No pending participants to show."
      }
      columns={columns}
      pagination={pagination}
    />
  );
};
